import { useUniqueIds } from '@/composables/useUniqueIds';
import { PerfChartSymbol } from '@/interfaces/chart';

const PERF_CHART_SYMBOL_TEMPLATE = {
  symbol: ''
};

const MAXIMUM_NUMBER_OF_PERF_CHART_SYMBOLS = 9;
const MAXIMUM_NUMBER_OF_PERF_CHART_SYMBOLS_FOR_FREE_USERS = 4;

function getBlankPerfChartSymbol(): PerfChartSymbol {
  const { getPositiveUniqueId } = useUniqueIds();

  return {
    ...PERF_CHART_SYMBOL_TEMPLATE,
    id: getPositiveUniqueId()
  };
}

function formatPerfChartSymbol(symbol: string): string {
  if (typeof symbol !== 'string') {
    return '';
  }

  return symbol.replace(/\s/g, '').toUpperCase();
}

function getPerfChartSymbolsString(perfChartSymbols: PerfChartSymbol[], additionalSymbol?: string, shouldAddSpacesBetweenSymbols?: boolean): string {
  const symbols = perfChartSymbols
    .map(perfChartSymbol => formatPerfChartSymbol(perfChartSymbol.symbol))
    .filter(symbol => symbol);

  const extraSymbol = formatPerfChartSymbol(additionalSymbol ?? '');

  if (extraSymbol) {
    symbols.unshift(extraSymbol);
  }

  return [ ...new Set(symbols) ].join(shouldAddSpacesBetweenSymbols ? ', ' : ',');
}

function getPerfChartSymbols(symbols: string): PerfChartSymbol[] {
  let symbolsArray = symbols
    .split(',')
    .map(formatPerfChartSymbol)
    .filter(symbol => symbol);

  symbolsArray = [ ...new Set(symbolsArray) ];

  return symbolsArray.map(symbol => {
    return {
      ...getBlankPerfChartSymbol(),
      symbol
    };
  });
}

export function usePerfChartSymbols() {
  return {
    MAXIMUM_NUMBER_OF_PERF_CHART_SYMBOLS,
    MAXIMUM_NUMBER_OF_PERF_CHART_SYMBOLS_FOR_FREE_USERS,
    getBlankPerfChartSymbol,
    formatPerfChartSymbol,
    getPerfChartSymbolsString,
    getPerfChartSymbols
  };
}
